import React, { useState } from 'react';
import styled from '@emotion/styled';
import DownArrowIcon from '../../../svg/DownArrowIcon';
import DownArrowIcon2 from '../../../svg/DownArrowIcon2';

const StyledFaqs = styled.div`
	h4 {
		font-size: ${(props) => (props.titleFontSize || '32') + 'px'};
		line-height: ${(props) => (props.titleLineHeight || '40') + 'px'};
		letter-spacing: 0.25px;
		color: ${(props) => props.titleColor || '#212121'};
	}

	p {
		font-size: 16px;
		line-height: 24px;
		letter-spacing: 0.15px;
		color: ${(props) => props.copyColor || '#545454'};
	}
`;

const StyledFaqsItems = styled.div``;

const StyledFaqsItem = styled.div`
	border-bottom: 1px solid #e3e3e3;
	padding: 24px 0 20px;
	max-height: 64px;
	overflow: hidden;
	transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);

	svg {
		transition: transform 0.3s ease-in-out;
	}

	&.active {
		transition: max-height 0.3s ease-in-out;
		max-height: 999px;

		svg {
			transform: rotate(180deg);
		}
	}
`;

const StyledShowAll = styled.div`
	> div {
		width: 40px;
		height: 40px;
		border-radius: 100%;
		transition: transform 0.3s ease-in-out, background-color 0.3s ease-in-out;

		&:hover {
			background-color: #e9e9e9;
		}

		&.active {
			transform: rotate(-180deg);
		}
	}
`;

function TitleWithImage({
	props: {
		title,
		titleColor,
		titleAlignment,
		titleFontSize,
		titleLineHeight,
		copy,
		copyColor,
		copyAlignment,
		items: { items },
		showAll,
	},
}) {
	const [activeItems, setActiveItems] = useState([]);
	const [showAllItems, setShowAllItems] = useState(false);

	const toggleItem = (index) => {
		let activeItemsTemp = [...activeItems];

		if (activeItemsTemp.indexOf(index) > -1) {
			activeItemsTemp = activeItemsTemp.filter((item) => item !== index);
		} else {
			activeItemsTemp.push(index);
		}

		setActiveItems(activeItemsTemp);
	};

	return (
		<div className='container'>
			<StyledFaqs
				titleColor={titleColor}
				copyColor={copyColor}
				titleFontSize={titleFontSize}
				titleLineHeight={titleLineHeight}
			>
				{title && <h4 className={'mb-20 text-' + titleAlignment}>{title}</h4>}
				{copy && <p className={'mb-20 text-' + copyAlignment}>{copy}</p>}
				{items.length > 0 ? (
					<>
						<StyledFaqsItems>
							{items.map((item, index) => {
								if (showAll || showAllItems || index < 5) {
									let { title, description } = item;
									if (title && description) {
										return (
											<StyledFaqsItem
												key={index}
												onClick={() => toggleItem(index)}
												className={`cursor-pointer ${
													activeItems.indexOf(index) > -1 ? 'active' : ''
												}`}
											>
												<div className='font-weight-bold mb-24 d-flex align-items-center justify-content-between'>
													{title}
													<DownArrowIcon />
												</div>
												<div>{description}</div>
											</StyledFaqsItem>
										);
									}
								}
							})}
						</StyledFaqsItems>
						{!showAll && (
							<StyledShowAll
								className='text-center mt-20'
								onClick={() => {
									setShowAllItems(!showAllItems);
								}}
							>
								<div
									className={`d-inline-block cursor-pointer p-8 ${
										showAllItems && 'active'
									}`}
								>
									<DownArrowIcon2 />
								</div>
							</StyledShowAll>
						)}
					</>
				) : null}
			</StyledFaqs>
		</div>
	);
}

export default TitleWithImage;
